import { useState, useEffect } from 'react';
import __isEmpty from 'lodash/isEmpty';
import Imatge from 'components/3catinfo/Imatge';
import Text from 'components/3catinfo/Text';
import Icona from 'components/3catinfo/ui/Icona';
import clsx from 'clsx';
import styles from './cardcandidat.module.scss';

export default function CardCandidat(props) {
    const { id, nom, foto, partit, logoPartit, descripcio, cita, partits, colorPartit } = props;
    const color = partits?.find((p) => p.id === id)?.rgbcolor ?? colorPartit;

    const [visible, setVisible] = useState(false);

    const styleDesplegat = clsx({
        [styles.mesInfo]: true,
        [styles.ocult]: !visible
    });

    const styleContentFoto = clsx({
        [styles.contentFoto]: true,
        [styles.ocult]: !visible
    });

    const styleBotoMesInfo = clsx({
        [styles.botoMesInfo]: true,
        [styles.ocult]: !visible
    });

    const styleContent = clsx({
        [styles.content]: true,
        [styles.contentAmbCita]: cita
    });

    useEffect(() => {
        setVisible(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nom]);

    return (
        <div role='article' className={styles.card}>
            <div className={styleContent}>
                <div className={styles.contentLeft}>
                    <div className={styles.contentPartit}>
                        <div className={styles.contentLogoPartit}>
                            <Imatge className={styles.logoPartit} src={logoPartit} layout='fill' objectFit='contain' />
                        </div>
                    </div>
                    <div className={styles.contentNom}>
                        <div className={styles.nom}>{nom}</div>
                        <div className={styles.infoPartit}>{partit}</div>
                    </div>
                    <button className={styleBotoMesInfo} onClick={() => setVisible(!visible)}>
                        <span>{visible ? "Mostra'n menys" : 'Coneix el candidat'}</span>
                        <Icona
                            icona={visible ? 'fletxa_simple_amunt' : 'fletxa_simple_avall'}
                            alt=''
                            isBlanc={true}
                            inline={true}
                            className={styles.icona}
                        />
                    </button>
                </div>
                <div className={styleContentFoto} style={{ '--color-partit': color }}>
                    <div className={styles.foto}>
                        <Imatge src={foto} layout='fill' objectFit='cover' />
                    </div>
                    {!__isEmpty(cita) && (
                        <div className={styles.cita}>
                            <blockquote>
                                <div className={styles.obrirCita}>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        width='48'
                                        height='48'
                                        viewBox='0 0 48 48'
                                        fill='none'
                                    >
                                        <path
                                            d='M13.6705 20.7273C17.8879 20.7273 21.3068 24.1462 21.3068 28.3636C21.3068 32.581 17.8879 36 13.6705 36C9.453 36 6.03409 
                                        32.581 6.03409 28.3636L6 27.2727C6 18.8378 12.8378 12 21.2727 12V16.3636C18.3588 16.3636 15.6193 17.4984 13.5588 19.5588C13.1622 
                                        19.9555 12.8002 20.3776 12.4737 20.8209C12.8637 20.7595 13.2633 20.7273 13.6705 20.7273ZM33.3068 20.7273C37.5242 20.7273 40.9432 
                                        24.1462 40.9432 28.3636C40.9432 32.581 37.5242 36 33.3068 36C29.0894 36 25.6705 32.581 25.6705 28.3636L25.6364 27.2727C25.6364 
                                        18.8378 32.4741 12 40.9091 12V16.3636C37.9953 16.3636 35.2556 17.4984 33.1952 19.5588C32.7985 19.9555 32.4365 20.3776 32.11 
                                        20.8209C32.5 20.7595 32.8996 20.7273 33.3068 20.7273Z'
                                            fill='#FFF'
                                        />
                                    </svg>
                                </div>
                                <p>{cita}</p>
                            </blockquote>
                        </div>
                    )}
                </div>
            </div>
            <div className={styleDesplegat}>
                <div className={styles.colLeft}>
                    <Text text={descripcio?.naixement} className={styles.descripcioNaixement}></Text>
                    <Text text={descripcio?.politica} className={styles.descripcioPolitica}></Text>
                    <Text text={descripcio?.estudisIProfessio} className={styles.descripcioEstudisIProfessio}></Text>
                </div>
            </div>
        </div>
    );
}
